import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

// Add Authorization header from localStorage as fallback to cookies
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 and 403 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config.url?.includes('/auth/login')) {
      localStorage.removeItem('access_token');
    }
    if (error.response?.status === 403 && error.response?.data?.detail?.includes('subscription') || error.response?.data?.detail?.includes('trial')) {
      // Store the message and redirect to subscription page
      localStorage.setItem('subscription_blocked', error.response.data.detail);
      window.location.href = '/subscription-required';
    }
    return Promise.reject(error);
  }
);

export default api;
